/**
 * Blog Carousel - JavaScript
 * Handles Swiper initialization and responsive behavior
 * Consistent with collection-carousel.js patterns
 */

(function () {
  "use strict";

  var swiperInstances = new Map();

  function ensureSwiper(sectionElement, callback) {
    if (window.Swiper) {
      callback();
      return;
    }

    var scriptSrc = sectionElement.dataset.swiperSrc;
    var existingScript = document.querySelector(
      'script[src*="swiper-bundle.min.js"]',
    );

    if (existingScript) {
      existingScript.addEventListener("load", callback, { once: true });
      return;
    }

    var script = document.createElement("script");
    script.src = scriptSrc;
    script.async = true;
    script.addEventListener("load", callback, { once: true });
    document.head.appendChild(script);
  }

  /**
   * Initialize a blog carousel
   */
  function initBlogCarousel(sectionElement) {
    if (!window.Swiper) {
      ensureSwiper(sectionElement, function () {
        initBlogCarousel(sectionElement);
      });
      return;
    }

    var sectionId = sectionElement.dataset.sectionId;

    // Prevent double initialization on the same DOM element
    if (sectionElement._blogCarouselInitialized) {
      return;
    }

    var carouselElement = sectionElement.querySelector(
      "[data-blog-carousel-swiper]",
    );
    if (!carouselElement) {
      return;
    }

    var carouselKey = sectionId + "-blog-carousel";

    // Check if already in instances map
    if (swiperInstances.has(carouselKey)) {
      return swiperInstances.get(carouselKey);
    }

    var swiperConfig = {
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 16,
      breakpoints: {
        320: {
          spaceBetween: 12,
        },
        768: {
          spaceBetween: 16,
        },
        1025: {
          spaceBetween: 16,
        },
      },

      // Performance & tracking
      watchSlidesProgress: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,

      // Touch & drag settings
      simulateTouch: true,
      allowTouchMove: true,
      touchRatio: 1,
      resistance: true,
      resistanceRatio: 0.85,
      threshold: 5,
      followFinger: true,
      shortSwipes: true,
      longSwipes: true,
      touchEventsTarget: "container",

      // Layout
      centeredSlides: false,
      updateOnWindowResize: true,
      resizeObserver: true,

      // Navigation (inside swiper container, same as collection-carousel)
      navigation: {
        nextEl: carouselElement.querySelector(".swiper-button-next"),
        prevEl: carouselElement.querySelector(".swiper-button-prev"),
      },

      // Transitions
      speed: 600,
      cssMode: false,

      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous article",
        nextSlideMessage: "Next article",
      },

      // Events
      on: {
        init: function () {
          updateNavVisibility(this, carouselElement);
        },
        breakpoint: function () {
          updateNavVisibility(this, carouselElement);
        },
        resize: function () {
          updateNavVisibility(this, carouselElement);
        },
      },
    };

    var blogSwiper = new Swiper(carouselElement, swiperConfig);
    swiperInstances.set(carouselKey, blogSwiper);
    sectionElement._blogCarouselInitialized = true;
  }

  /**
   * Update navigation button visibility
   * Hide when all slides fit in the viewport
   */
  function updateNavVisibility(swiperInstance, carouselElement) {
    var prevBtn = carouselElement.querySelector(".swiper-button-prev");
    var nextBtn = carouselElement.querySelector(".swiper-button-next");

    if (!prevBtn || !nextBtn || !swiperInstance) return;

    if (swiperInstance.isLocked) {
      prevBtn.style.setProperty("display", "none", "important");
      nextBtn.style.setProperty("display", "none", "important");
    } else {
      prevBtn.style.removeProperty("display");
      nextBtn.style.removeProperty("display");
    }
  }

  /**
   * Initialize all blog carousels on the page
   */
  function initAll() {
    var sections = document.querySelectorAll(
      '[data-section-type="blog-carousel"]',
    );
    sections.forEach(function (section) {
      initBlogCarousel(section);
    });
  }

  /**
   * Cleanup all instances
   */
  function cleanupAll() {
    swiperInstances.forEach(function (swiper, key) {
      swiper.destroy(true, false);
    });
    swiperInstances.clear();

    var sections = document.querySelectorAll(
      '[data-section-type="blog-carousel"]',
    );
    sections.forEach(function (section) {
      section._blogCarouselInitialized = false;
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(
      '[data-section-type="blog-carousel"]',
    );
    if (section) {
      initBlogCarousel(section);
    }
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector(
      '[data-section-type="blog-carousel"]',
    );
    if (section) {
      var sectionId = section.dataset.sectionId;
      var carouselKey = sectionId + "-blog-carousel";

      if (swiperInstances.has(carouselKey)) {
        swiperInstances.get(carouselKey).destroy(true, false);
        swiperInstances.delete(carouselKey);
        section._blogCarouselInitialized = false;
      }
    }
  });

  document.addEventListener("shopify:section:reorder", function () {
    cleanupAll();
    initAll();
  });

  // Handle window resize (debounced)
  var resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      swiperInstances.forEach(function (swiper) {
        if (swiper && swiper.update) {
          swiper.update();
        }
      });
    }, 250);
  });

  // Cleanup on page unload
  window.addEventListener("beforeunload", cleanupAll);
})();
